import { Input } from './ui/input';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Signal, Wallet } from 'lucide-react';

// Blank state for a two-provider Data + Voice entry form.
// Data defaults to GB (staff read GB off their phones); converted to MB on save.
export const EMPTY_BALANCES = {
  p1_data_mb: '', p1_voice_naira: '', p2_data_mb: '', p2_voice_naira: '',
  p1_data_unit: 'GB', p2_data_unit: 'GB',
};

// Validate the four numeric fields and convert Data GB → MB (1 GB = 1000 MB).
// The backend always stores MB. Returns { ok, parsed } or { ok:false, error }.
export const parseMobileBalances = (vals) => {
  const parsed = {};
  for (const k of ['p1_data_mb', 'p1_voice_naira', 'p2_data_mb', 'p2_voice_naira']) {
    const n = parseFloat(vals[k]);
    if (Number.isNaN(n) || n < 0) {
      return { ok: false, error: 'Please enter all four balances (valid, non-negative)' };
    }
    parsed[k] = n;
  }
  if ((vals.p1_data_unit || 'MB') === 'GB') parsed.p1_data_mb = parsed.p1_data_mb * 1000;
  if ((vals.p2_data_unit || 'MB') === 'GB') parsed.p2_data_mb = parsed.p2_data_mb * 1000;
  return { ok: true, parsed };
};

// One provider's Data (with MB/GB unit toggle) + Voice (₦) inputs.
// SHARED by the Mobile Balances page (Enter tab) AND the Morning balance gate
// so the GB/MB toggle + conversion can never drift between the two again.
export const MobileDataVoiceInput = ({ prefix, name, vals, setV, testid }) => {
  const unit = vals[`${prefix}_data_unit`] || 'MB';
  return (
    <div className="rounded-lg border border-forest-100 p-3 space-y-3">
      <p className="text-sm font-semibold text-forest-800">{name}</p>
      <div className="grid grid-cols-5 gap-3">
        <div className="space-y-1.5 col-span-3">
          <Label className="text-xs flex items-center gap-1.5"><Signal className="w-3.5 h-3.5 text-forest-700" /> Data ({unit})</Label>
          <div className="flex gap-1.5">
            <Input type="number" inputMode="decimal" step="0.01" min="0" placeholder={unit === 'GB' ? 'e.g. 1.25' : 'e.g. 1250.50'}
              value={vals[`${prefix}_data_mb`]} onChange={(e) => setV(`${prefix}_data_mb`, e.target.value)}
              className="min-w-0 flex-1"
              data-testid={`${testid}-${prefix}-data`} />
            <Select value={unit} onValueChange={(v) => setV(`${prefix}_data_unit`, v)}>
              <SelectTrigger className="w-[64px] shrink-0" data-testid={`${testid}-${prefix}-data-unit`}><SelectValue /></SelectTrigger>
              <SelectContent className="z-[100001]"><SelectItem value="MB">MB</SelectItem><SelectItem value="GB">GB</SelectItem></SelectContent>
            </Select>
          </div>
        </div>
        <div className="space-y-1.5 col-span-2">
          <Label className="text-xs flex items-center gap-1.5"><Wallet className="w-3.5 h-3.5 text-forest-700" /> Voice (₦)</Label>
          <Input type="number" inputMode="decimal" step="0.01" min="0" placeholder="e.g. 450.00"
            value={vals[`${prefix}_voice_naira`]} onChange={(e) => setV(`${prefix}_voice_naira`, e.target.value)}
            data-testid={`${testid}-${prefix}-voice`} />
        </div>
      </div>
    </div>
  );
};
